import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Hero from "./components/Hero";
import StatsSection from "./components/StatsSection";
import BrandLogos from "./components/BrandLogos";
import AudienceInsights from "./components/AudienceInsights";
import ContentShowcase from "./components/ContentShowcase";
import CaseStudies from "./components/CaseStudies";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import { FinalCTA, Footer } from "./components/CTAandFooter";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'Results', href: '#results' },
    { label: 'Services', href: '#services' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-[#0A0F0D]/95 backdrop-blur-md border-b border-[#22C55E]/10' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="text-2xl font-bold">
            <span className="text-white">Alex</span>
            <span className="text-[#22C55E]">Morgan</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-[#94A3B8] hover:text-[#22C55E] transition-colors duration-300 font-medium"
              >
                {link.label}
              </a>
            ))}
            <button className="bg-[#16A34A] hover:bg-[#22C55E] text-white px-6 py-2 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#22C55E]/30">
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="block text-[#94A3B8] hover:text-[#22C55E] transition-colors duration-300 font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <button className="w-full bg-[#16A34A] hover:bg-[#22C55E] text-white px-6 py-2 rounded-lg font-semibold transition-all duration-300">
              Contact
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

const Home = () => {
  return (
    <div className="bg-[#0A0F0D]">
      <Navbar />
      <Hero />
      <BrandLogos />
      <StatsSection />
      <AudienceInsights />
      <ContentShowcase />
      <CaseStudies />
      <Services />
      <Testimonials />
      <FinalCTA />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
